import { useMemo, useState, useCallback } from "react";
import styles from "./styles.module.scss";
import cn from "classnames";
import PlayGroup from "@/assets/playgroup.svg"; // ✅ use your custom asset

function toEmbedUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url);
    let id = "";

    if (u.hostname.includes("youtu.be")) {
      id = u.pathname.replace("/", "");
    } else if (u.searchParams.get("v")) {
      id = u.searchParams.get("v") || "";
    } else if (u.pathname.startsWith("/embed/")) {
      return url;
    }

    if (!id) return "";
    return `https://www.youtube-nocookie.com/embed/${id}`;
  } catch {
    return "";
  }
}

export const Video = ({ youtubeUrl, placeholder, className }) => {
  const [playing, setPlaying] = useState(false);

  const baseEmbed = useMemo(() => toEmbedUrl(youtubeUrl), [youtubeUrl]);

  const src = useMemo(() => {
    if (!baseEmbed) return "";
    const params = new URLSearchParams({
      rel: "0",
      modestbranding: "1",
      playsinline: "1",
      ...(playing ? { autoplay: "1" } : {}),
    });
    return `${baseEmbed}?${params.toString()}`;
  }, [baseEmbed, playing]);

  const onPlay = useCallback(() => setPlaying(true), []);

  return (
    <section className={cn(styles.Video, className)}>
      <div className={styles.wrapper}>
        <div className={cn(styles.canvas, playing && styles.isPlaying)} onClick={!playing ? onPlay : undefined}>
          {/* YouTube iframe */}
          <div className={styles.embed}>
            <iframe
              src={src}
              title="Embedded Video"
              allow="autoplay; encrypted-media; clipboard-write; picture-in-picture"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              loading="lazy"
              frameBorder="0"
            />
          </div>

          {/* overlay only when not playing */}
          {!playing && (
            <>
              <img src={placeholder?.url} alt="Video placeholder" className={styles.placeholder} draggable={false} />
              <button className={styles.badge} aria-label="Play video" type="button" onClick={onPlay}>
                <PlayGroup className={styles.playIcon} /> {/* ✅ your custom SVG */}
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Video;
